import { Icon } from '#/components/Icon/Icon';
import type { SocialNetwork } from '#/types/SocialNetwork';
import { iconNameBySocialNetwork } from '#/utils/social/iconNameBySocialNetwork';

import {
  SocialLinksLi,
  SocialLinksUl,
  SocialLink,
  SocialLinksCandidLink,
} from './SocialLinks.styled';

const socialNetworkLabels: Record<SocialNetwork, string> = {
  candid: 'Candid',
  facebook: 'Facebook',
  instagram: 'Instagram',
  linkedin: 'LinkedIn',
  tiktok: 'TikTok',
  x: 'X',
  youtube: 'YouTube',
};

type Props = {
  socialLinks: { link: string; socialNetwork: SocialNetwork }[];
  qaId: string;
};

export function SocialLinks({ socialLinks, qaId }: Props) {
  return (
    <SocialLinksUl data-qa-id={qaId}>
      {socialLinks.map(({ socialNetwork, link }) => {
        const label = socialNetworkLabels[socialNetwork];
        const LinkComponent =
          socialNetwork === 'candid' ? SocialLinksCandidLink : SocialLink;

        return (
          <SocialLinksLi key={link}>
            <LinkComponent
              type="link"
              href={link}
              title={label}
              aria-label={label}
            >
              <Icon name={iconNameBySocialNetwork[socialNetwork]} size={16} />
            </LinkComponent>
          </SocialLinksLi>
        );
      })}
    </SocialLinksUl>
  );
}
